import { SET_ITEMS, ADD_ITEM, REMOVE_ITEM } from './types';

export function setItems(data) {
	return {
		type: SET_ITEMS,
		payload: data
	};
}

export function addItem(item) {
	return {
		type: ADD_ITEM,
		payload: item
	};
}

export function removeItem(itemName) {
	return {
		type: REMOVE_ITEM,
		payload: itemName
	};
}
